import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ControlCenterType } from '../control-center'

@Directive({
  selector: '[appControlCenterTypeSelect]',
})
export class ControlCenterTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'context.type'
    this.select.displayProperty = 'value'
    this.select.dataSource = enumTranslationService.enumDataSource(
      ControlCenterType,
      'shopfloor.controlcenters.type',
      false
    )
  }
}
